export default __webpack_public_path__ + "a3477aa9719737de7e14fd80ceccf458.png";